import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { dayLabel, type SeriesPoint } from '../lib/radar-trends';
import { decimal } from '../lib/time';

// The radar chart's text alternative (#6715), the `ChartWidget.tsx` pattern: the
// drawn chart is hidden from assistive tech, and this unstyled, visually hidden
// table carries every point it plots. Not a <DataTable/>: that would put a
// focusable scroll stop inside invisible text (`data-table-usage.test.ts` EXEMPT).

export function AdminTrendTable(props: {
  title: string;
  series: readonly SeriesPoint[];
  today: string;
}): JSX.Element {
  return (
    <table class="sr-only">
      <caption>{t('admin.trend_table_caption', { title: props.title })}</caption>
      <thead>
        <tr>
          <th scope="col">{t('admin.trend_col_day')}</th>
          <th scope="col">{t('admin.trend_col_value')}</th>
        </tr>
      </thead>
      <tbody>
        <For each={props.series}>
          {(p) => (
            <tr>
              <td>{dayLabel(p.day, props.today)}</td>
              <td>{decimal(p.value)}</td>
            </tr>
          )}
        </For>
      </tbody>
    </table>
  );
}
